import { jsx as _jsx } from "react/jsx-runtime";
import { CenteredText } from '@/core/styled';
import { FullStretchPaperStyled } from './FullStretchLoadingPaper.styled';
export const FullStretchLoadingPaper = ({ children }) => {
    return (_jsx(FullStretchPaperStyled, { children: _jsx(CenteredText, { children: children }) }));
};
